/* project tokens */
export const PROJECT_DETAILS_TOKENS_ACTIVATE = 'PROJECT_DETAILS_TOKEN_RACK_ACTIVATE';
export const PROJECT_DETAILS_TOKENS_DEACTIVATE = 'PROJECT_DETAILS_TOKEN_RACK_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/actions/tokens.ts